import { Meta } from '../types/docs';

const META: Meta = {
  name: 'shown_inactivity_modal',
  description: 'Inactivity logout modal is shown to user',
};

export default META;
